import { ISaveServiceRequestResponse } from "../../../Orchestrator/Types/Interface/IServiceRequest";



export class ServiceRequestClaimDetailsContext {

    public routeTo: string[] = [];
    public bookingId: string = "";
    public ticketList: ISaveServiceRequestResponse[] = []
    constructor() {

    }
}